import { render } from "./PatientCaseReview.vue?vue&type=template&id=448b1ac2&scoped=true"
const script = {}

import "./PatientCaseReview.vue?vue&type=style&index=0&id=448b1ac2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448b1ac2"]])

export default __exports__